import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gutter-y-s3"
}

import { ref } from 'vue';
import { PortfolioFarm } from '@/sdk/entities/portfolioFarm';
import ControlPanelCollapse from '@/components/ControlPanelCollapse.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import TokenData from '@/views/pages/liquidity/single-side/components/TokenData.vue';
import TokenWithdraw from '@/views/pages/liquidity/single-side/withdraw/TokenWithdraw.vue';
import { SingleSideToken } from '../models/single-side-token';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenListWithdraw',
  props: {
    noFeeLimit: null,
    sortBy: null,
    sortDirection: null,
    tokens: null,
    farms: null
  },
  emits: ["send-transaction"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'send-transaction'): void;
}), expose: any, slots: any, attrs: any }) {





const isExpandedByToken = ref<Record<string, boolean>>({});

const onExpanded = (token: SingleSideToken, isExpanded: boolean) => {
  isExpandedByToken.value[token.id] = isExpanded;
};

const onSendTransaction = () => {
  emits('send-transaction');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.tokens.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tokens, (token) => {
            return (_openBlock(), _createElementBlock("div", {
              key: token.id
            }, [
              _createVNode(ControlPanelCollapse, {
                crosschain: token.isCrossChain,
                "onUpdate:expanded": ($event: any) => (onExpanded(token, $event)),
                "toggle-inline": ""
              }, {
                "header-title": _withCtx(() => [
                  _createVNode(TokenIcon, {
                    "icon-src": token.portfolioToken.tokenIconUrl,
                    full: "",
                    symbol: token.portfolioToken.symbol
                  }, null, 8, ["icon-src", "symbol"])
                ]),
                "header-data": _withCtx(() => [
                  _createVNode(TokenData, {
                    token: token,
                    action: 'withdraw'
                  }, null, 8, ["token"])
                ]),
                default: _withCtx(() => [
                  _createVNode(TokenWithdraw, {
                    "is-show": isExpandedByToken.value[token.id] ?? false,
                    token: token,
                    farm: __props.farms[token.id],
                    onSendTransaction: onSendTransaction
                  }, null, 8, ["is-show", "token", "farm"])
                ]),
                _: 2
              }, 1032, ["crosschain", "onUpdate:expanded"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})